import { useCallback } from 'react';

import { cx } from '@libs/classnames';
import { CapsuleButton } from '@ui/components/CapsuleButton';

import { Achievement } from '@features/shared/api/typings';

import styles from './PlayerAchievementLargePreview.module.css';

type Props = {
  className?: string;
  achievement: Achievement;
  onClick?: (achievement: Achievement) => void;
};
export function PlayerAchievementLargePreview({ className, achievement, onClick }: Props) {
  const handleClick = useCallback(() => {
    onClick?.(achievement);
  }, [onClick, achievement]);

  return (
    <div className={styles.achievementContainer}>
      <div className={cx(styles.achievement, className)}>
        <img src={achievement.tournamentCertificate?.svgSrc} className={styles.previewContainer} />
      </div>
      <CapsuleButton preset="call-to-action" onClick={handleClick}>
        Скачать
      </CapsuleButton>
    </div>
  );
}
